{
  "rightSidebar": {
    "placeholder": "Tento panel je zástupný obsah.",
    "chat": {
      "placeholder": "Spýtaj sa na toto jedlo…"
    },
    "favourites": {
      "empty": "Tvoje najčastejšie zaznamenané jedlá sa zobrazia tu, keď si zaznamenáš nejaké jedlo."
    },
    "tabs": {
      "coach": "Tréner výživy",
      "recipes": "Recepty",
      "favourites": "Obľúbené"
    }
  },
  "title": "Jedlá",
  "subtitle": "Nabite svoj progres",
  "loading": "Načítavam...",
  "logMeal": "Zaznamenať jedlo",
  "logMealSubtitle": "Výživa",
  "mealType": {
    "breakfast": "Raňajky",
    "lunch": "Obed",
    "dinner": "Večera",
    "snack": "Snack"
  },
  "empty": {
    "title": "Žiadne jedlá nezaznamenané",
    "description": "Zaznamenajte svoje prvé jedlo a sledujte výživu",
    "slotSubtitle": "Ešte nezaznamenané"
  },
  "logMealAction": "Zaznamenať jedlo",
  "addAction": "Pridať",
  "addAnotherItem": "Pridať ďalšiu položku",
  "search": "Hľadať",
  "scan": "Skenovať",
  "macroShort": "S{{carbs}} B{{protein}} T{{fats}}",
  "unnamedMeal": "Nepomenované jedlo",
  "deleteConfirmation": {
    "description": "Naozaj chcete odstrániť '{{name}}'? Túto akciu nie je možné vrátiť späť."
  },
  "type": {
    "BREAKFAST": "Raňajky",
    "LUNCH": "Obed",
    "DINNER": "Večera",
    "SNACK": "Snack"
  },
  "form": {
    "title": {
      "create": "Zaznamenať jedlo",
      "detail": "Detail jedla"
    },
    "meal": "Jedlo",
    "selectMeal": "Vyberte jedlo",
    "scanBarcode": "Naskenovať čiarový kód",
    "selectMealButton": "Vybrať jedlo...",
    "consumedAmount": "Množstvo",
    "consumedAt": "Dátum a čas",
    "mealType": "Typ jedla",
    "selectMealType": "Vyberte typ jedla...",
    "nutritionPreview": "Nutričné informácie",
    "errors": {
      "mealRequired": "Prosím vyberte jedlo",
      "amountRequired": "Prosím zadajte platné množstvo"
    }
  },
  "mealSelector": {
    "title": "Vybrať jedlo",
    "description": "Vyhľadajte jedlo na zaznamenanie",
    "barcodeResults": "Jedlá zodpovedajúce naskenovanému čiarovému kódu",
    "createCustom": "Vytvoriť vlastné jedlo",
    "searchPlaceholder": "Hľadať jedlá...",
    "resultsPlaceholder": "Začnite písať pre vyhľadávanie jedlá",
    "filters": {
      "all": "Všetky",
      "recent": "Nedávne",
      "favorites": "Obľúbené",
      "custom": "Vlastné",
      "water": "Voda"
    }
  },
  "scanner": {
    "title": "Naskenovať čiarový kód",
    "permissionMessage": "Pre skenovanie čiarových kódov je potrebný prístup ku kamere. Prosím, povoľte prístup ku kamere.",
    "enableCamera": "Povoliť kameru"
  },
  "createMeal": {
    "title": "Vlastné jedlo",
    "subtitle": "Pridaj nutričné hodnoty a vlastné porcie",
    "nutritionTitle": "Nutričné hodnoty",
    "nutritionPer100g": "na 100 g",
    "servingUnits": {
      "title": "Jednotky porcie",
      "subtitle": "Vlastné porcie sa automaticky prepočítajú zo 100 g",
      "baseUnit": "Základná jednotka",
      "count_one": "{{count}} jednotka",
      "count_few": "{{count}} jednotky",
      "count_many": "{{count}} jednotiek",
      "count_other": "{{count}} jednotiek",
      "namePlaceholder": "Názov jednotky",
      "weightPlaceholder": "0",
      "addUnit": "Pridať jednotku",
      "summary": "≈ {{kcal}} kcal · B {{protein}}g · S {{carbs}}g · T {{fats}}g"
    },
    "fields": {
      "name": {
        "label": "Názov jedla",
        "placeholder": "Zadajte názov jedla"
      },
      "brand": {
        "label": "Značka (voliteľné)",
        "placeholder": "Zadajte značku"
      },
      "barcode": {
        "label": "Čiarový kód",
        "placeholder": "Zadajte čiarový kód"
      },
      "category": {
        "label": "Kategória (voliteľná)",
        "placeholder": "Vyberte kategóriu"
      },
      "servingSize": {
        "label": "Veľkosť porcie",
        "placeholder": "Zadajte veľkosť porcie"
      },
      "servingUnit": {
        "label": "Jednotka porcie",
        "placeholder": "Vyberte jednotku porcie"
      },
      "nutritionalInfo": "Nutričné informácie (na 100g)",
      "energyKcal": {
        "label": "Kalórie (kcal)",
        "placeholder": "Zadajte kalórie"
      },
      "protein": {
        "label": "Bielkoviny (g)",
        "placeholder": "Zadajte bielkoviny"
      },
      "carbs": {
        "label": "Sacharidy (g)",
        "placeholder": "Zadajte sacharidy"
      },
      "fats": {
        "label": "Tuky (g)",
        "placeholder": "Zadajte tuky"
      },
      "fibre": {
        "label": "Vláknina (g)",
        "placeholder": "Zadajte vlákninu"
      }
    },
    "actions": {
      "cancel": "Zrušiť",
      "create": "Vytvoriť jedlo",
      "update": "Aktualizovať jedlo"
    }
  },
  "summary": {
    "title": "Denná výživa",
    "subtitle": "Vaše jedlá za dnes",
    "totalCalories": "Celkové kalórie",
    "totalProtein": "Bielkoviny",
    "totalCarbs": "Sacharidy",
    "totalFats": "Tuky",
    "meals": "Jedlá",
    "units": {
      "kcal": "kcal",
      "meals": "jedál"
    }
  },
  "history": {
    "thisWeek": "Tento týždeň",
    "today": "Dnes",
    "yesterday": "Včera",
    "empty": "Žiadne jedlá tento týždeň",
    "mealsLogged_one": "{{count}} jedlo zaznamenané",
    "mealsLogged_other": "{{count}} jedál zaznamenaných",
    "ofGoal": "z cieľa"
  },
  "stats": {
    "title": "Týždenný priemer",
    "avgCalories": "Priem. kalórie",
    "avgProtein": "Priem. bielkoviny",
    "avgCarbs": "Priem. sacharidy",
    "avgFats": "Priem. tuky"
  },
  "customMeals": {
    "title": "Moje jedlá",
    "add": "Pridať",
    "empty": "Zatiaľ žiadne vlastné jedlá"
  },
  "favorites": {
    "title": "Obľúbené",
    "empty": "Zatiaľ žiadne obľúbené jedlá",
    "loggedTimes_one": "Zaznamenané {{count}}x",
    "loggedTimes_other": "Zaznamenané {{count}}x"
  },
  "nutrition": {
    "title": "VÝŽIVA",
    "total": "Spolu",
    "source": "Zdroj",
    "eaten": "zjedené",
    "remaining": "zostáva",
    "dailyTarget": "denný cieľ",
    "water": "Voda",
    "waterProgress": "{{current}} / {{target}}",
    "calories": {
      "longLabel": "Kalórie"
    },
    "protein": {
      "longLabel": "Bielkoviny"
    },
    "carbs": {
      "longLabel": "Sacharidy",
      "shortSign": "S: {{value}}g"
    },
    "fats": {
      "longLabel": "Tuky",
      "shortSign": "T: {{value}}g"
    },
    "fiber": {
      "longLabel": "Vláknina",
      "shortSign": "Vl: {{value}}g"
    },
    "kcal": {
      "shortSign": "{{value}}kcal",
      "unit": "kcal"
    },
    "proteins": {
      "shortSign": "B: {{value}}g"
    }
  },
  "units": {
    "GRAMS": {
      "shortSign": "g"
    },
    "KILOGRAMS": {
      "shortSign": "kg"
    },
    "OUNCES": {
      "shortSign": "oz"
    },
    "POUNDS": {
      "shortSign": "lb"
    },
    "MILLILITRES": {
      "shortSign": "ml"
    },
    "LITRES": {
      "shortSign": "l"
    },
    "CUPS": {
      "shortSign": "šálka"
    },
    "TABLESPOONS": {
      "shortSign": "PL"
    },
    "TEASPOONS": {
      "shortSign": "CL"
    },
    "PIECES": {
      "shortSign": "ks"
    },
    "SLICES": {
      "shortSign": "plátok"
    },
    "FLUID_OUNCES": {
      "shortSign": "fl oz"
    }
  },
  "copy": {
    "action": "Kopírovať",
    "moveAction": "Presunúť",
    "deleteAction": "Odstrániť",
    "actionsLabel": "Akcie záznamu jedla",
    "selectAction": "Vybrať",
    "dayAction": "Kopírovať deň",
    "dayMoveAction": "Presunúť deň",
    "slotAction": "Kopírovať {{slot}}",
    "slotMoveAction": "Presunúť {{slot}}",
    "dayActionsLabel": "Akcie dňa",
    "slotActionsLabel": "Akcie: {{slot}}",
    "selection": {
      "title_one": "Vybraná {{count}} položka",
      "title_few": "Vybrané {{count}} položky",
      "title_other": "Vybraných {{count}} položiek",
      "empty": "Nie sú vybrané žiadne položky",
      "emptyHint": "Vyberte aspoň jednu položku",
      "breakdownItem": "{{count}} {{slot}}",
      "breakdownSeparator": " · ",
      "selectAll": "Vybrať všetko",
      "cancel": "Zrušiť výber"
    },
    "modal": {
      "title_copy_one": "Kopírovať {{count}} položku",
      "title_copy_few": "Kopírovať {{count}} položky",
      "title_copy_other": "Kopírovať {{count}} položiek",
      "title_move_one": "Presunúť {{count}} položku",
      "title_move_few": "Presunúť {{count}} položky",
      "title_move_other": "Presunúť {{count}} položiek",
      "description": "Vyberte, kam sa majú zapísať. Ak deň nezmeníte, každý záznam zostane presne tam, kde bol zaznamenaný.",
      "dayLabel": "Deň",
      "dateLabel": "Cieľový deň",
      "dateCaption": "Ponechanie pôvodného dňa nechá zaznamenaný čas nezmenený.",
      "slotLabel": "Jedlo",
      "keepOriginal": "Ponechať pôvodný čas",
      "cancel": "Zrušiť",
      "confirm_copy_one": "Kopírovať {{count}} položku",
      "confirm_copy_few": "Kopírovať {{count}} položky",
      "confirm_copy_other": "Kopírovať {{count}} položiek",
      "confirm_move_one": "Presunúť {{count}} položku",
      "confirm_move_few": "Presunúť {{count}} položky",
      "confirm_move_other": "Presunúť {{count}} položiek"
    },
    "summary": {
      "title_copy_one": "Skopírovaná {{count}} položka",
      "title_copy_few": "Skopírované {{count}} položky",
      "title_copy_other": "Skopírovaných {{count}} položiek",
      "title_move_one": "Presunutá {{count}} položka",
      "title_move_few": "Presunuté {{count}} položky",
      "title_move_other": "Presunutých {{count}} položiek",
      "description": "Jeden riadok pre každý cieľový deň a jedlo. Vrátiť späť sa dá, kým nestlačíte Hotovo.",
      "line_one": "{{count}} položka",
      "line_few": "{{count}} položky",
      "line_other": "{{count}} položiek",
      "lineDestination": "{{day}} · {{slot}}",
      "namesMore": "+{{count}} ďalších",
      "undo": "Vrátiť späť",
      "done": "Hotovo",
      "undoError": "Teraz sa to nepodarilo vrátiť. Skúste to znova alebo stlačte Hotovo a zmenu ponechajte.",
      "degradedDescription": "Detaily sa nepodarilo zobraziť, ale zmena prebehla.",
      "degradedLine_copy": "{{count}} položiek → skopírovaných",
      "degradedLine_move": "{{count}} položiek → presunutých"
    }
  }
}
